/**
 * These utils take in a map of 1-1 IDs.
 * This is different to the graphUtils because they have a map of 1-* IDs.
 */
export const getAllAncestorIds = ({ parentIdMap, startingId }) => {
    const ancestorIds = [];
    const visitedAncestors = {};
    let ancestorId = parentIdMap[startingId];

    while (ancestorId) {
        ancestorIds.push(ancestorId);
        ancestorId = parentIdMap[ancestorId];

        if (visitedAncestors[ancestorId]) {
            console.warn(`Infinite loop in treeUtils/getAllAncestorIds for: ${startingId}`);
            break;
        }
        visitedAncestors[ancestorId] = true;
    }

    return ancestorIds;
};
